import React from "react";
import { Grid, Typography, TextField, FormControlLabel, Switch, Box, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

const VerificationOfPossibleCauses = (props) => {
    const { t } = useTranslation();
    const theme = useTheme();
    return (
        <Grid container xs={6} sm={6} md={6}>
            <Box
                sx={{
                    width: "98%",
                    px: 1,
                    py: 1,
                    m: 1,
                    mt: 0,
                    alignItems: "center",
                    backgroundColor: theme.palette.grey[100],
                    borderRadius: "12px",
                    boxShadow: 3,
                    gap: 2
                }}
            >
                <Grid item xs={12} sm={12}>
                    <Typography variant="h6" align="center" sx={{ fontSize: 15, backgroundColor: "#DEE0E0" }}>
                        {t("VerificationOfPossibleCauses")}
                    </Typography>
                </Grid>

                <Grid container xs={12} sm={12} md={12} padding={1}>
                    {/*A*/}
                    <Grid container xs={12} sm={12} padding={1} sx={{ display: "flex" }}>
                        <Grid item xs={1} sm={1} sx={{ display: "grid", alignContent: "center" }}>
                            <Typography variant="h6" align="center" sx={{ fontSize: 15, fontWeight: "bold" }}>
                                A
                            </Typography>
                        </Grid>
                        <Grid item xs={9} sm={9}>
                            <Typography variant="h6" align="center" sx={{ fontSize: 15, fontWeight: "bold" }}>
                                <TextField
                                    size="small"
                                    type="primary"
                                    disabled={props.disableStates.isPossibleCauseADisable}
                                    value={props.possibleCauseA}
                                    onChange={props.handlePossibleCauseAChange}
                                    fullWidth
                                    error={props.hasPossibleCauseAError}
                                    helperText={props.possibleCauseAErrorText}
                                ></TextField>
                            </Typography>
                        </Grid>
                        <Grid item xs={2} sm={2} sx={{ display: "grid", alignContent: "center", paddingLeft: 1 }}>
                            <FormControlLabel
                                id="bl_formControl_2"
                                control={
                                    <Switch
                                        id="ef_causeAStatusSwitch"
                                        disabled={props.disableStates.isPossibleCauseAStatusDisable}
                                        checked={props.possibleCauseAStatus}
                                        onChange={() => props.setPossibleCauseAStatus(!props.possibleCauseAStatus)}
                                        color="primary"
                                        name="checkedMe"
                                        inputProps={{ "aria-label": "controlled" }}
                                    />
                                }
                                label={t("OK")}
                            />
                        </Grid>
                    </Grid>
                    {/*B*/}
                    <Grid container xs={12} sm={12} padding={1} sx={{ display: "flex" }}>
                        <Grid item xs={1} sm={1} sx={{ display: "grid", alignContent: "center" }}>
                            <Typography variant="h6" align="center" sx={{ fontSize: 15, fontWeight: "bold" }}>
                                B
                            </Typography>
                        </Grid>
                        <Grid item xs={9} sm={9}>
                            <Typography variant="h6" align="center" sx={{ fontSize: 15, fontWeight: "bold" }}>
                                <TextField
                                    size="small"
                                    type="primary"
                                    disabled={props.disableStates.isPossibleCauseBDisable}
                                    value={props.possibleCauseB}
                                    onChange={(event) => props.setPossibleCauseB(event.target.value)}
                                    fullWidth
                                ></TextField>
                            </Typography>
                        </Grid>
                        <Grid item xs={2} sm={2} sx={{ display: "grid", alignContent: "center", paddingLeft: 1 }}>
                            <FormControlLabel
                                id="bl_formControl_2"
                                control={
                                    <Switch
                                        id="ef_causeBStatusSwitch"
                                        disabled={props.disableStates.isPossibleCauseBStatusDisable}
                                        checked={props.possibleCauseBStatus}
                                        onChange={() => props.setPossibleCauseBStatus(!props.possibleCauseBStatus)}
                                        color="primary"
                                        name="checkedMe"
                                        inputProps={{ "aria-label": "controlled" }}
                                    />
                                }
                                label={t("OK")}
                            />
                        </Grid>
                    </Grid>
                    {/*C*/}
                    <Grid container xs={12} sm={12} padding={1} sx={{ display: "flex" }}>
                        <Grid item xs={1} sm={1} sx={{ display: "grid", alignContent: "center" }}>
                            <Typography variant="h6" align="center" sx={{ fontSize: 15, fontWeight: "bold" }}>
                                C
                            </Typography>
                        </Grid>
                        <Grid item xs={9} sm={9}>
                            <Typography variant="h6" align="center" sx={{ fontSize: 15, fontWeight: "bold" }}>
                                <TextField
                                    size="small"
                                    type="primary"
                                    disabled={props.disableStates.isPossibleCauseCDisable}
                                    value={props.possibleCauseC}
                                    onChange={(event) => props.setPossibleCauseC(event.target.value)}
                                    fullWidth
                                ></TextField>
                            </Typography>
                        </Grid>
                        <Grid item xs={2} sm={2} sx={{ display: "grid", alignContent: "center", paddingLeft: 1 }}>
                            <FormControlLabel
                                id="bl_formControl_2"
                                control={
                                    <Switch
                                        id="ef_causeCStatusSwitch"
                                        disabled={props.disableStates.isPossibleCauseCStatusDisable}
                                        checked={props.possibleCauseCStatus}
                                        onChange={() => props.setPossibleCauseCStatus(!props.possibleCauseCStatus)}
                                        color="primary"
                                        name="checkedMe"
                                        inputProps={{ "aria-label": "controlled" }}
                                    />
                                }
                                label={t("OK")}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </Grid>
    );
};

export default VerificationOfPossibleCauses;
